// extracted by mini-css-extract-plugin
module.exports = {"button":"_393b8e9"};